<template>
  <div class="meteo">
    <transition name="fade" mode="out-in">
      <img v-show="info" :src="require(`../assets/${url}.jpg`)" class="meteo-img">
    </transition>
    <div class="layout"></div>
    <div :class=" {active:info, content:true}">
      <header class="search">
        <input type="text" autocomplete="off" placeholder="Recherche une ville..." v-model="ville" @keyup.enter="getdata()">
        <img src="../assets/location-pointer.svg" @click="getcoord()">
      </header>
      <div v-if="!info&&load" class="load"><img src="../assets/loading.svg"></div>
      <main v-if="info">
        <section class="location">
          <div class="city">{{this.info.city.name}}, {{this.info.city.country}}</div>
          <div class="date">{{getdate()}}</div>
        </section>
        <div class="current">
          <div class="temp">{{Math.round(this.info.list[0].main.temp)}}°C</div>
          <div class="weather">{{this.info.list[0].weather[0].description}}</div>
          <div class="hi-low">{{Math.round(this.min)}}°C / {{Math.round(this.max)}}°C</div>
        </div>
        <div class="prevision">
          <div class="prevision-1">
            {{this.info.list[0].dt_txt.slice(10,16)}}
            <img :src="`http://openweathermap.org/img/wn/${getimg(this.info.list[0].weather[0].main)}@2x.png`">{{Math.round(this.info.list[0].main.temp)}}°C
          </div>
          <div class="prevision-2">
            {{this.info.list[1].dt_txt.slice(10,16)}}
            <img :src="`http://openweathermap.org/img/wn/${getimg(this.info.list[1].weather[0].main)}@2x.png`">{{Math.round(this.info.list[1].main.temp)}}°C
          </div>
          <div class="prevision-3">
            {{this.info.list[2].dt_txt.slice(10,16)}}
            <img :src="`http://openweathermap.org/img/wn/${getimg(this.info.list[2].weather[0].main)}@2x.png`">{{Math.round(this.info.list[2].main.temp)}}°C
          </div>
          <div class="prevision-4">
            {{this.info.list[3].dt_txt.slice(10,16)}}
            <img :src="`http://openweathermap.org/img/wn/${getimg(this.info.list[3].weather[0].main)}@2x.png`">{{Math.round(this.info.list[3].main.temp)}}°C
          </div>
          <div class="prevision-5">
            {{this.info.list[4].dt_txt.slice(10,16)}}
            <img :src="`http://openweathermap.org/img/wn/${getimg(this.info.list[4].weather[0].main)}@2x.png`">{{Math.round(this.info.list[4].main.temp)}}°C
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: "Meteo",
  data:()=>({
    ville:"",
    load:false,
    info: undefined,
    min:undefined,
    max:undefined,
    coords: undefined,
    url:"50d"
  }),
  methods:{
    changebg(){
      this.url=this.getimg(this.info.list[0].weather[0].main);
    },
    getdata(){
      this.info= undefined;
      this.load=true;
      fetch(`https://api.openweathermap.org/data/2.5/forecast?q=${this.ville}&appid=5b5ff9070712aa947961830ff6bc1e0c&cnt=5&units=metric&lang=fr`)
      .then(response=>{
        if(response.ok)
          return response.json();
        else
          return undefined;
      }).then(data=>{
        this.info=data;
        if(this.info){
          this.changebg()
        }
      })
      fetch(`https://api.openweathermap.org/data/2.5/weather?q=${this.ville}&appid=5b5ff9070712aa947961830ff6bc1e0c&units=metric&lang=fr`)
      .then(response=>{
        if(response.ok)
          return response.json();
        else
          return undefined;
      }).then(data=>{
        if(data){
          this.min=data.main.temp_min;
          this.max=data.main.temp_max;
        }
      })
      this.ville="";
    },
    getdate(){
      let d=new Date();
      return d.toLocaleString('fr-FR',{ weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    },
    getcoord(){
      this.info= undefined;
      this.load=true;
      if (navigator.geolocation && !this.coords) {
        navigator.geolocation.getCurrentPosition((pos)=>this.coords=pos);
          
      }
      if(this.coords){
        fetch(`https://api.openweathermap.org/data/2.5/forecast?lat=${this.coords.coords.latitude}&lon=${this.coords.coords.longitude}&appid=5b5ff9070712aa947961830ff6bc1e0c&cnt=5&units=metric&lang=fr`)
        .then(response=>{
          if(response.ok)
            return response.json();
          else
            return undefined;
        }).then(data=>{
          this.info=data;
          if(this.info){
            this.changebg()
          }
        })
        fetch(`https://api.openweathermap.org/data/2.5/weather?lat=${this.coords.coords.latitude}&lon=${this.coords.coords.longitude}&appid=5b5ff9070712aa947961830ff6bc1e0c&units=metric&lang=fr`)
        .then(response=>{
          if(response.ok)
            return response.json();
          else
            return undefined;
        }).then(data=>{
          if(data){
            this.min=data.main.temp_min;
            this.max=data.main.temp_max;
          }
        })
      }
    },
    getimg(e){
      switch(e){
        case 'Thunderstorm': return '11d';
        case 'Drizzle': return '09d';
        case 'Rain': return '10d';
        case 'Snow': return '13d';
        case 'Clear': return '01d';
        case 'Clouds': return '03d';
        default: return '50d';
      }
    }
  }
};
</script>
<style scoped>
.meteo {
  height: 90vh;
  width: 100vw;
  position: relative;
  background: url("../assets/50d.jpg");
  background-size: cover;
  background-position: top center;
}
.meteo-img{
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
}
.layout {
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}
.content{
  position: absolute;
  top: 20%;
  left: 0;
  right: 0;
  width: 30%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.4);
  font-family: 'Montserrat', sans-serif;
  overflow: hidden;
  transition: all 0.25s ease-in;
}
.active{
  animation: slide 1s linear forwards;
  height: 70%;
}
.search img{
  width: 35px;
  cursor: pointer;
}
header{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 15px 15px;
}
header input{
  width: 100%;
  padding: 10px 25px;
  border: none;
  outline: none;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 16px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.3);
  color: #313131;
  font-size: 20px;
  font-weight: 400;
  transition: 0.4s ease-out;
}
header input:focus{
  background-color: rgba(255, 255, 255, 0.8);
}
main{
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #fff;
}
.location .city{
  font-size: 32px;
  font-weight: 500;
  margin-bottom: 5px;
}
.location .date{
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
}
.current .temp{
  font-family: 'Montserrat', sans-serif;
  font-size: 50px;
  font-weight: 900;
  margin: 15px 0px;
  text-shadow: 2px 8px rgba(0, 0, 0, 0.4);
}
.current .weather{
  font-family: 'Montserrat', sans-serif;
  font-size: 32px;
  font-weight: 700;
  font-style: italic;
  text-shadow: 0px 3p rgba(0, 0, 0, 0.4);
}
.current .hi-low{
  font-size: 24px;
  font-weight: 500;
  text-shadow: 0px 4px rgba(0, 0, 0, 0.4);
}
.load img{
  width: 50px;
  animation: rotate 3s linear infinite;
}
.prevision{
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  margin-top: 15px;
  transition: all 0.5s ease-in-out;
}
.prevision div{
  display: flex;
  flex-direction: column;
  align-items: center;

}
.prevision img{
  width: 60px;
}
.prevision{
  opacity: 0;
}
.content:hover .prevision{
  opacity: 1;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s ease-in-out;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}

@keyframes slide {
  from{
    opacity: 0;
  }
  to{
    height: 70%;
    opacity: 1;
  }
}
@keyframes rotate {
  from{
    transform: rotate(0deg);
  }
  to{
    transform: rotate(360deg);
  }
}
@media screen and (max-width: 400px) {
  .content{
    top: 10%;
    width: 90%;
  }
}
@media screen and (min-width: 400px) and (max-width: 1100px) {
  .content{
    top: 10%;
    width: 90%;
  }
}
</style>